/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '../../../common/ui';
import issueBreakdownLineSvg from '../assets/issue-breakdown-line.tpl.svg';
import issueBreakdownSvg from '../assets/issue-breakdown.tpl.svg';

const svgStyles = css({
	borderLeftWidth: '1em',
	borderRightWidth: '1em',
});

export const IssueBreakdownSkeleton = () => (
	<AppSkeletonImage src={issueBreakdownSvg} css={svgStyles} containerStyles={{ height: '7em' }} />
);

export const IssueBreakdownLineSkeleton = () => (
	<AppSkeletonImage
		src={issueBreakdownLineSvg}
		css={svgStyles}
		containerStyles={{ height: '3.4em' }}
	/>
);
